module.exports = __webpack_public_path__ + "img/11.56dc86b1.jpg";